import { IAppState } from '../../../redux';
import { selectIsAddressEditingWarningVisible } from './selectIsAddressEditingWarningVisible';
import { selectConfigValue } from '../../config';

export const selectMaxAddressEditingDays = (state: IAppState): number | null => {
  const isWarningVisible = selectIsAddressEditingWarningVisible(state);
  const maxDays = selectConfigValue('maxAddressEditingDays')(state);

  return isWarningVisible ? maxDays : null;
};
